import { Component } from '@angular/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-page-toolbar',
    template: `
        <div class="content-column content">
            <ng-content select="[content]"></ng-content>
        </div>
        <div class="content-column">
            <div class="left">
                <ng-content select="[left]"></ng-content>
            </div>
            <div class="right">
                <ng-content select="[right]"></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./page-toolbar.component.scss']
})
export class PageToolbarComponent {}
